import { useDispatch } from "react-redux";
import SecondaryBtn from "../../../../components/common/form/SecondaryBtn";
import { Add, Pattern } from "../../../../components/common/svg/AllSvg";
import { dataActions } from "../../../../shared/store/data-Slice";
import { useEffect, useState } from "react";
import { url } from "../../../../shared/utils/url";
import useAxios from "../../../../shared/hooks/use-axios";
import { useTranslation } from "react-i18next";

const Banner = () => {
    const dispatch = useDispatch();
    const [result, setResult] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const { t } = useTranslation('common');
    const data: any[] = [
        { id: 1, name: t("recruitment.hr.home.status.status1"), key: "active_advertisement" },
        { id: 2, name: t("recruitment.hr.home.status.status2"), key: "active_job" },
        { id: 3, name: t("recruitment.hr.home.status.status3"), key: "new_registration" },
        { id: 4, name: t("recruitment.hr.home.status.status4"), key: "shortlisted" }
    ]
    const color: any[] = [
        { border: "border-[#FCAB02]", color: "#FCAB02" },
        { border: "border-[#02C0FC]", color: "#02C0FC" },
        { border: "border-[#02FC84]", color: "#02FC84" },
        { border: "border-[#0AE194]", color: "#0AE194" }
    ]

    const getStatistics = async () => {
        try {
            const res: any = await useAxios.get(`${url?.hrStatistics}`);

            if (res && res.status === 200) {
                setResult(res?.data?.results)
                setLoading(false)
            }
        } catch (error) {
            console.error("error while fetching statistics", error);
        }
    }

    useEffect(() => {
        getStatistics();
    }, [])

    return (
        <div className="flex items-center justify-center w-full h-full rounded-b-[25px] lg:rounded-b-[50px] hiring-bg">
            <div className="container h-full py-[25px] xlsm:py-[35px] flex flex-col">
                <div className="flex items-center justify-between w-full xlsm:flex-row flex-col gap-[15px]">
                    <div className="flex flex-col gap-[2px] order-2 xlsm:order-1 justify-start xlsm:w-auto w-full">
                        <h2 className="text-[2.188rem] text-[#242555] dark:text-white font-bold uppercase">{t("recruitment.hr.home.title")}</h2>
                        <h5 className="text-[#3D3D3D] dark:text-textBlackDark font-medium">{t("recruitment.hr.home.desc")}</h5>
                    </div>

                    <div className="justify-end flex xlsm:w-auto w-full order-1 xlsm:order-2">
                        <SecondaryBtn title={t("recruitment.hr.home.create_ad")} css="px-[12px] xlx:px-[15px] font-bold rounded-[6px] text-sm !gap-[10px] whitespace-nowrap uppercase" leftIcon={<Add />} onClick={() => dispatch(dataActions.setCreateAd(true))} />
                    </div>
                </div>
                <div className="mt-[35px] grid grid-cols-1 xsm:grid-cols-2 msm:grid-cols-4 gap-[20px] xlx:gap-[25px]">
                    {Array.isArray(data) && data?.map((item: any, index: number) => (
                        <div key={index} className={`${color?.[index]?.border} border w-full h-[100px] rounded-[15px] lg:rounded-[20px] bg-white py-[15px] xlx:py-[18px] px-[15px] xlsm:px-[20px] xlx:px-[24px] flex items-center xsm:items-start xlsm:items-center mm:items-start xl:items-center justify-between relative`}>
                            <div className="flex flex-col justify-between h-full">
                                {loading ?
                                    <div className="w-[30px] h-[30px] bg-gray-200 rounded dark:bg-gray-700 animate-pulse"></div>
                                    : <h3 className="text-[1.75rem] text-primaryText font-bold leading-snug">{result[item?.key]}</h3>}
                                <div className="absolute top-0 left-0 right-0 bottom-0 flex items-end justify-start py-[15px] xlx:py-[18px] px-[15px] xlsm:px-[20px] xlx:px-[24px]">
                                    <h6 className="text-primary font-bold uppercase">{item?.name}</h6>
                                </div>
                            </div>

                            <Pattern className="min-w-[128px]" color={color?.[index]?.color} stroke="#6E7C87" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Banner;